module.exports = __webpack_public_path__ + "4c1195472f1e91e42c042160781f7ab6.MP3";